import React from 'react';
import useThumbnailCarousel from './useThumbnailCarousel';
import ThumbnailImage from './ThumbnailImage';

const ThumbnailCarousel = props => {
  const {
    thumbnailsListRef,
    imageIds,
    selectedImageId,
    priorityLimit,
    scrollToImage,
    mainImageButtonClick
  } = useThumbnailCarousel(props);

  return (
    <div className="thumbnail-carousel" data-testid="thumbnail-carousel">
      <div className="thumbnail-carousel__main_image_container">
        <div
          id="previous-button"
          className="thumbnail-carousel__main_image_container__button"
          role="button"
          onClick={() => mainImageButtonClick()}>
          <div className="arrow arrow--left" />
        </div>
        <ThumbnailImage {...props} priority imageId={selectedImageId} />
        <div
          id="next-button"
          className="thumbnail-carousel__main_image_container__button next"
          role="button"
          onClick={() => mainImageButtonClick(true)}>
          <div className="arrow arrow--right" />
        </div>
      </div>
      <div className="thumbnail-carousel__list" ref={thumbnailsListRef}>
        {imageIds.map((imageId, index) => (
          <ThumbnailImage
            {...props}
            key={imageId}
            imageIndex={index}
            priority={index < priorityLimit}
            imageId={imageId}
            selectedImageId={selectedImageId}
            scrollToImage={scrollToImage}
          />
        ))}
      </div>
    </div>
  );
};

export default ThumbnailCarousel;
